const productClickAnalyticsMapper = require('./gtmmapper/productclick-analytics-mapper');

class ShelfProductVariantController {
    constructor(config, trolleyService, gtmService) {
        this.config = config;
        this.trolleyService = trolleyService;
        this.gtmService = gtmService;
    }

    $onInit() {
        this.defaultImagePath = this.config.DefaultProductImageSmall;
    }

    gtmProductClickDataPush() {
        this.gtmService.push(this.product, productClickAnalyticsMapper);
    }
}

const shelfProductVariantComponentDefinition = {
    bindings: {
        product: '<',
        totalVariants: '=',
    },
    controller: ['config', 'TrolleyService', 'GtmService', ShelfProductVariantController],
    template: require('./shelf-product-variant.component.html').trim(),
};

module.exports = {
    ShelfProductVariantController,
    shelfProductVariantComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/shelfproduct/shelf-product-variant.component.js